export default __webpack_public_path__ + "static/media/default-page-vitrine.562bc09a.jpg";